<template>
  <div class="textarea-emoji-picker">
    <textarea
      ref="textarea"
      class="textarea"
      :value="value"
      @input="$emit('input', $event.target.value)"
    ></textarea>
  </div>
</template>

<script>
  import { Picker } from 'emoji-mart-vue'

  export default {
    components: { Picker },

    props: {
      value: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped>
  * {
    box-sizing: border-box;
  }
  .textarea-emoji-picker {
    position: relative;
    width: 400px;
    margin: 0 auto;
  }
  .textarea {
    width: 100%;
    min-height: 300px;
    outline: none;
    box-shadow: none;
    padding: 10px 28px 10px 10px;
    font-size: 15px;
    border: 1px solid #BABABA;
    color: #333;
    border-radius: 2px;
    box-shadow: 0px 2px 4px 0 rgba(0,0,0,0.1) inset;
    resize: vertical;
  }
  .emoji-mart {
    position: absolute;
    top: 33px;
    right: 10px;
  }
  .emoji-trigger {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    height: 20px;
  }
  .emoji-trigger path {
    transition: 0.1s all;
  }
  .emoji-trigger:hover path {
    fill: #000000;
  }
  .emoji-trigger.triggered path {
    fill: darken(#FEC84A, 15%);
  }
</style>